import React from 'react';
import doctorStore from './items/doctor';
import shopStore from './items/shop';
import dealStore from './items/deal';

export const stores = Object.freeze({
  doctorStore,
  shopStore,
  dealStore,
});

export const storesContext = React.createContext(stores);
export const StoresProvider = storesContext.Provider;
